import Head from 'react-helmet'
import React, { useState } from 'react'
import useDidMount from '../../hooks/useDidMount'
import generatePageTitle from '../../domain/seo/useCases/generatePageTitle'
import generatePageDescription from '../../domain/seo/useCases/generatePageDescription'
import replaceCustomShortCodes from '../../utils/replaceCustomShortCodes'
import { computeLuxuryCanonical } from '../../domain/useCases/computeLuxuryCanonical'
import { isFacetPageType } from '../../domain/useCases/pageTypeCheck'

const SEO = ({
  title,
  termData,
  pageType = 'Location',
  gatsbyCount,
  searchResults,
  path,
  customTitle,
  customDescription,
  imgUrl,
  pathParam,
  noIndex = false,
  shouldDefaultRegionalize = false,
  location
}) => {
  const didMount = useDidMount()

  // do not make this dynamic (update value upon request only)
  const year = 2025

  const count = gatsbyCount || searchResults?.nbHits || 0
  const secondaryTerm = termData.title

  const customTitleWithShortCodeReplaced = replaceCustomShortCodes({
    originalString: customTitle,
    count,
    year,
    secondaryTerm
  })
  const customDescriptionWithShortCodeReplaced = replaceCustomShortCodes({
    originalString: customDescription,
    count,
    year,
    secondaryTerm
  })

  const pageTitle = generatePageTitle({
    title,
    year,
    term: termData.title,
    pageType,
    customTitle: customTitleWithShortCodeReplaced,
    count,
    shouldDefaultRegionalize,
    location
  })

  const pageDescription = generatePageDescription({
    pageType,
    title,
    term: termData.title,
    customDescription: customDescriptionWithShortCodeReplaced,
    count,
    location,
    shouldDefaultRegionalize
  })

  const canonicalUrl = computeLuxuryCanonical(
    path,
    pathParam,
    pageType,
    location
  )

  let renderedOgUrl = canonicalUrl

  if (isFacetPageType(pageType) && !didMount) {
    renderedOgUrl = `${canonicalUrl}${title.toLowerCase()}/${termData.slug}/`
  }

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta
          name="description"
          content={pageDescription}
        />
        <meta
          property="og:title"
          content={pageTitle}
        />
        <meta
          property="og:description"
          content={pageDescription}
        />
        <meta
          property="og:url"
          content={renderedOgUrl}
        />
        <meta
          property="og:type"
          content="website"
        />
        <meta
          property="og:image"
          content={imgUrl}
        />
        <meta
          property="og:image:width"
          content="1200"
        />
        <meta
          property="og:image:height"
          content="630"
        />
        <meta
          property="twitter:title"
          content={pageTitle}
        />
        <meta
          property="twitter:description"
          content={pageDescription}
        />
        <meta
          property="twitter:image"
          content={imgUrl}
        />
        <meta
          property="twitter:card"
          content="summary_large_image"
        />
        <meta
          property="twitter:site"
          content="@DotComRecovery"
        />
        {(!isFacetPageType(pageType) || didMount) && (
          <link
            rel="canonical"
            href={canonicalUrl}
          />
        )}
        {noIndex && (
          <meta
            name="robots"
            content="noindex"
          />
        )}
      </Head>
    </>
  )
}

export default SEO
